import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=c73d8cf0&"
var script = {}
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=c73d8cf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports